/* eslint-disable import/prefer-default-export */
/* eslint-disable import/no-extraneous-dependencies */
import Handlebars from 'handlebars';

export const compileWithHandlebars = (template, data) => {
    const compiledTemplate = Handlebars.compile(template);
    return compiledTemplate(data);
};
